module.exports = __webpack_public_path__ + "/img/bd791d69074738e5229bdbe172cccc28.png";